module.exports = __webpack_public_path__ + "static/3q1-d3031f006d1b73163796deb51130a3e3.svg";